import React from 'react'
import {
  UserOutlined,
  LockOutlined,
  SafetyOutlined,
  // StarOutlined,
  EllipsisOutlined,
} from '@ant-design/icons'
import { Menu } from 'antd'
import { NavLink } from 'react-router-dom'
import styled from '@emotion/styled'
import { useLocation } from 'react-router-dom'

const Item = styled(NavLink)`
  color: inherit;
`

const MenuItem = ({ icon, path, label }) => {
  return (
    <Item to={path}>
      {icon}

      <span>{label}</span>
    </Item>
  )
}

const SettingsMenu = () => {
  const location = useLocation()
  const paths = location.pathname.split('/').filter(item => item !== '')
  const currentPath = paths[paths.length - 1]

  return (
    <Menu
      mode="inline"
      defaultSelectedKeys={[currentPath]}
      items={[
        {
          key: 'settings',
          label: <MenuItem label="Perfil" icon={<UserOutlined />} path="." />,
        },
        {
          key: 'change-password',
          label: (
            <MenuItem
              label="Alterar a senha"
              icon={<LockOutlined />}
              path="change-password"
            />
          ),
        },
        {
          key: 'ssh-keys',
          label: (
            <MenuItem
              label="Chaves SSH"
              icon={<SafetyOutlined />}
              path="ssh-keys"
            />
          ),
        },
        // {
        //   key: 'rewards',
        //   label: (
        //     <MenuItem
        //       label="Recompensas"
        //       icon={<StarOutlined />}
        //       path="rewards"
        //     />
        //   ),
        // },
        {
          key: 'other',
          label: (
            <MenuItem label="Outros" icon={<EllipsisOutlined />} path="other" />
          ),
        },
        // {
        // 	key: 'address',
        // 	label: <MenuItem label="Endereços" icon={<HomeOutlined />} path="/address" />
        // },
        // {
        // 	key: 'notification',
        // 	label: <MenuItem label="Notificações" icon={<BellOutlined />} path="/notification" />
        // },
      ]}
    />
  )
}

export default SettingsMenu
